import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./wrapper.scss";

const Wrapper = (props) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]); // scroll to top on render

  return <div className="wrapper">{props.children}</div>;
};

export default Wrapper;
